import apiClient, { extractApiPayloadMessage, getApiErrorMessage } from './apiClient';

const assertAdminSuccess = (payload, fallbackMessage) => {
  if (payload && typeof payload === 'object' && payload.success === false) {
    throw new Error(extractApiPayloadMessage(payload) || fallbackMessage);
  }
};

const normalizeUsers = (payload) => {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload?.items)) {
    return payload.items;
  }

  if (Array.isArray(payload?.data)) {
    return payload.data;
  }

  return [];
};

export const fetchProjectUsersApi = async (projectId) => {
  try {
    const { data } = await apiClient.get(`/projects/${encodeURIComponent(projectId)}/users`);
    assertAdminSuccess(data, 'Failed to load project users.');
    return normalizeUsers(data);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to load project users.'));
  }
};

export const createProjectUserApi = async ({ projectId, fullName, username, password, additionalFields }) => {
  try {
    const { data } = await apiClient.post(`/projects/${encodeURIComponent(projectId)}/users`, {
      fullName,
      username,
      password,
      additionalFields
    });
    assertAdminSuccess(data, 'Failed to create user.');

    return data;
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to create user.'));
  }
};

export const updateProjectUserApi = async ({ projectId, userId, fullName, username, password, additionalFields }) => {
  try {
    const { data } = await apiClient.put(
      `/projects/${encodeURIComponent(projectId)}/users/${encodeURIComponent(userId)}`,
      {
        fullName,
        username,
        password,
        additionalFields
      }
    );
    assertAdminSuccess(data, 'Failed to update user.');

    return data;
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to update user.'));
  }
};

export const deleteProjectUserApi = async ({ projectId, userId }) => {
  try {
    const { data } = await apiClient.delete(
      `/projects/${encodeURIComponent(projectId)}/users/${encodeURIComponent(userId)}`
    );
    assertAdminSuccess(data, 'Failed to delete user.');

    return data;
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to delete user.'));
  }
};
